import { DocumentsPageWithModal } from "./DocumentPage";
import { LetterHeadPageWithModal } from "./LetterHeadPage";
import { SignatoryPageWithModal } from "./SignatoryPage";

const OrganizationProfile = {
  DocumentsPageWithModal,
  LetterHeadPageWithModal,
  SignatoryPageWithModal,
};
export default OrganizationProfile;
